var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11534_99930)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8266 3.46274e-08C3.54651 3.46274e-08 2.31884 0.508516 1.41368 1.41368C0.508516 2.31884 0 3.54651 0 4.8266V11.7737C0.000273366 13.0537 0.508968 14.2812 1.41419 15.1861L16.8271 30.6007C18.3073 32.0808 20.6723 32.5088 22.5354 31.2893C26.0241 29.0048 29.0041 26.0253 31.2893 22.537C32.5088 20.6707 32.0808 18.3073 30.6007 16.8288L15.1877 1.41419C14.7394 0.96578 14.2072 0.610085 13.6214 0.367432C13.0356 0.124779 12.4078 -7.59129e-05 11.7737 3.46274e-08H4.8266ZM6.63658 8.44656C7.11662 8.44656 7.57699 8.25586 7.91643 7.91643C8.25586 7.57699 8.44656 7.11662 8.44656 6.63658C8.44656 6.15654 8.25586 5.69617 7.91643 5.35673C7.57699 5.0173 7.11662 4.8266 6.63658 4.8266C6.15654 4.8266 5.69617 5.0173 5.35673 5.35673C5.0173 5.69617 4.8266 6.15654 4.8266 6.63658C4.8266 7.11662 5.0173 7.57699 5.35673 7.91643C5.69617 8.25586 6.15654 8.44656 6.63658 8.44656Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11534_99930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
export default SvgTag;